/**
 * Tick
 * - a simple util to give some breathing room -
 * inspired by Svelts' tick.
 * in an async await spa world.
 * For example:
 * async example = ()=>{
 *   state.loading = true;
 *   let product = await getProducts();
 *   await tick(200) // will wait
 *   state.loading = false;
 * }
 */
export default (ms: number, func?: Function): Promise<any> => {
  return new Promise(resolve => {
    setTimeout(() => {
      if (func) {
        func();
      }
      resolve();
    }, ms);
  });
};
